import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col, Button } from '_zari/core'

import { NuevoTemaSeguimientoModal } from 'sharedComponents/modals'

import * as SociosSeguimientoService from 'services/sociosSeguimiento.service'

const TemasSeguimientoFormGroup = ({ vIdSocio, iError, iTouched, fIsSubmitting, handleChange, setFieldValue }) => {
  const __zariContext = React.useContext(ZariContext)
  const [mostrarNuevoModal, setMostrarNuevoModal] = React.useState(false)

  const [listaSeguimiento, setListaSeguimiento] = React.useState([])

  React.useEffect(() => {
    SociosSeguimientoService.obtenerxIdSocioAsSelect(vIdSocio)
      .then(({ data }) => setListaSeguimiento(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [vIdSocio, __zariContext])

  const clickNuevo = React.useCallback(() => {
    setMostrarNuevoModal(true)
  }, [])

  const onCreate = React.useCallback(() => {
    setMostrarNuevoModal(false)
    SociosSeguimientoService.obtenerxIdSocioAsSelect(vIdSocio)
      .then(({ data }) => setListaSeguimiento(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [vIdSocio, __zariContext])

  const onChange = React.useCallback(
    e => {
      handleChange(e)

      setFieldValue('mostrarDetalles', false)
    },
    [handleChange, setFieldValue]
  )

  return (
    <>
      <Form.Group>
        <Form.Label text='TEMAS' htmlFor='select-temasSeguimiento' md={2} alignRightAt='md' />
        <Col md={10}>
          <Field name='_idTemaSeguimiento'>
            {({ field }) => (
              <Form.InputGroup>
                <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-temasSeguimiento' onChange={onChange}>
                  <option value=''>Seleccionar</option>
                  {listaSeguimiento.map((val, key) => (
                    <option key={key} value={val._id}>
                      {val.tema}
                    </option>
                  ))}
                </Form.Select>
                <Form.InputGroup.Append>
                  <Button disabled={fIsSubmitting} onClick={clickNuevo}>
                    +
                  </Button>
                </Form.InputGroup.Append>
              </Form.InputGroup>
            )}
          </Field>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarNuevoModal && (
        <NuevoTemaSeguimientoModal handleClose={() => setMostrarNuevoModal(false)} show={mostrarNuevoModal} idSocio={vIdSocio} onCreate={onCreate} />
      )}
    </>
  )
}

export default React.memo(TemasSeguimientoFormGroup)
